<template>
  <div class="btn-group btn-group__actions" role="group">
    <b-dropdown
      class="dropdown__theme-light navbar__dropdown table__dropdown"
      right
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
    >
      <template v-slot:button-content>
          <span class="material-icons icon-image-preview">
            more_vert
          </span>
      </template>
      <b-dropdown-item-button v-if="!withoutAdd" @click.prevent="$emit('add')" >
        <span class="dropdown-item-link">
          Add
        </span>
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="isEdit" @click.prevent="$emit('edit')" >
        <span class="dropdown-item-link">
          Edit
        </span>
      </b-dropdown-item-button>
      <b-dropdown-item-button v-else @click.prevent="$emit('save')" >
        <span class="dropdown-item-link">
          Save
        </span>
      </b-dropdown-item-button>
      <b-dropdown-item-button @click.prevent="$emit('remove')" >
        <span class="dropdown-item-link">
          Delete
        </span>
      </b-dropdown-item-button>

    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'ReportTableControls',
  props: {
    isEdit: {
      type: Boolean,
      default: true
    },
    withoutAdd: {
      type: Boolean,
      default: false
    }
  }
}
</script>
